import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductVariantOptionService } from '../shared/product-variant-option.service';
import { ProductVariantOptionModel } from '../shared/product-variant-option.model';
import { CommonModule } from '@angular/common';
import { ArrowLeft, LucideAngularModule } from 'lucide-angular';
import { ButtonComponent } from '@app/partials/form/button/button.component';
import { DailyPricingCalendarComponent } from './daily-pricing-calendar.component';
import { DailyPricingBulkUpdateComponent } from './daily-pricing-bulk-update.component';

@Component({
  selector: 'app-product-variant-option-prices-calendar',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, ButtonComponent, DailyPricingCalendarComponent, DailyPricingBulkUpdateComponent],
  templateUrl: './product-variant-option-prices-calendar.component.html',
  styleUrl: './product-prices-calendar.component.css',
})
export class ProductVariantOptionPricesCalendarComponent implements OnInit {
  @ViewChild(DailyPricingCalendarComponent) calendarComponent!: DailyPricingCalendarComponent;
  @ViewChild(DailyPricingBulkUpdateComponent) bulkUpdateComponent!: DailyPricingBulkUpdateComponent;

  variantOption: ProductVariantOptionModel | null = null;
  protected readonly BackIcon = ArrowLeft;

  constructor(
    private route: ActivatedRoute,
    public variantOptionService: ProductVariantOptionService,
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.data['variantOption']) {
      this.variantOption = this.route.snapshot.data['variantOption'];
    }
  }

  getDailyPrices = () => {
    return this.variantOptionService.getDailyPrices(this.variantOption?.id || 0);
  }

  storeBulkDailyPrices = (data: any) => {
    return this.variantOptionService.storeBulkDailyPrices(this.variantOption?.id || 0, data);
  }

  deleteBulkDailyPrices = (data: any) => {
    return this.variantOptionService.deleteBulkDailyPrices(this.variantOption?.id || 0, data);
  }

  onBulkUpdateSuccess(): void {
    this.calendarComponent.refresh();
  }

  onPriceClick(event: { startDate: Date; endDate: Date; price: number | null }): void {
    this.bulkUpdateComponent.populateForm(event.startDate, event.endDate, event.price);
  }

  navigateBack(): void {
    window.history.back();
  }
}
